import { render } from "./pos-suppliers.vue?vue&type=template&id=28ccd787"
import script from "./pos-suppliers.vue?vue&type=script&lang=js"
export * from "./pos-suppliers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__